"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _pieChart.default;
  }
});
var _pieChart = _interopRequireDefault(require("./pieChart.js"));
module.exports = exports.default;
module.exports.default = exports.default;